export const emailRegex = RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
